import { Routes, Route } from 'react-router-dom';

import TopCharts from '@pages/ranking/topCharts';
import Mover from '@pages/ranking/mover';
import Loser from '@pages/ranking/loser';
import NewApps from '@pages/ranking/newApps';

const RankingRoutes = () => {
  return (
    <Routes>
      <Route path="/topCharts" element={<TopCharts />} />
      <Route path="/newApps" element={<NewApps />} />
      <Route path="/climbers" element={<Mover />} />
      <Route path="/loser" element={<Loser />} />
    </Routes>
  );
};

export default RankingRoutes;
